import React from 'react';
import Navigation from '../components/Navigation';
import FeaturesSection from '../components/FeaturesSection';
import Footer from '../components/Footer';

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-black flex flex-col">
      <Navigation />
      <div className="flex-1 pt-20">
        <FeaturesSection />
      </div>
      <Footer />
    </div>
  );
}